import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MyIcon from '../../../components/general/icon'
import { Image, Pagination, Tooltip} from 'antd'
import RibbonAlumniEvent from './ribbon'
import AddAlumniEvent from './add'
import AlumniEventDetail from './detail'
import DeleteAlumniEvent from './delete'
import AuditAlumniEvent from './audit'

export default function AlumniEvent() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [eventData, setEventData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [isAddEventVisible, setIsAddEventVisible] = useState(false)
  const [isAlumniEventDetailVisible, setIsAlumniEventDetailVisible] = useState(false)
  const [isDeleteEventVisible, setIsDeleteEventVisible] = useState(false)
  const [isAuditVisible, setIsAuditVisible] = useState(false)

  const initialConditions = {
    status: 0,
    organization_oid: '',
    keywords: '',
    sort_filter: 0,
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getEventData = () => {
    axios.post('/p/alumni/event/list/get', { 
      merchant_oid: merchantOid,
      status: filterValue.status,
      organization_oid: filterValue.organization_oid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setEventData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'events': response.data.events
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getEventData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue])

  const eventDetail = (oid) => {
    setIsAlumniEventDetailVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteEvent = (oid, name) => {
    setIsDeleteEventVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  // const getColor = (key) => {
  //   if (key === 2) return 'green'
  //   if (key === 3) return 'red'
  //   return 'black'
  // }

  // const openAudit = (oid, status, failure_reason) => {
  //   setIsAuditVisible(true)
  //   setPropsData({ 
  //     oid: oid,
  //     status: status,
  //     failureReason: failure_reason
  //   })
  // }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">活动管理</div>
          <RibbonAlumniEvent 
            filterValue={filterValue} 
            setFilterValue={setFilterValue} 
            isAddVisible={() => { setIsAddEventVisible(true) }}  
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px', width: '250px'}}>活动标题</th>
                <th>所属组织</th>
                <th>活动类型</th>
                <th>报名问题</th>
                <th>活动时间</th>
                {/* <th>活动状态</th> */}
                <th style={{width: '50px'}}></th>
              </tr>
            </thead>

            <tbody>
              {eventData.events && (eventData.events.length > 0 ? (eventData.events.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { eventDetail(item.oid) }}>
                  <td style={{ width: '250px', textAlign: 'left'}}>
                    {item.thumbnail_url ? 
                      <div className='public-main-style2-tuwen' style={{ display: 'flex'}}>
                        <div style={{ margin: '10px 15px 10px 0' }} onClick={(event) => { event.stopPropagation() }}>
                          <Image src={item.thumbnail_url} width={100} height={60} />
                        </div>
                        <span style={{
                          display: 'inline-block',
                          maxWidth: '250px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                          {item.title}
                        </span>
                      </div>
                      :
                      item.title
                    }
                  </td>
                  <td>{item.organization_name || '-'}</td>
                  <td>{item.type_value}</td>
                  <td>{item.has_question}</td>
                  <td>{item.event_time}</td>
                  {/* <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td> */}
                  <td style={{width: '50px'}}>
                    <div className='public-main-style2-operation-box'>
                      {/* <Tooltip placement="bottom" color='#1A1B1C' title="审核">
                        <div className='public-main-style2-operation' onClick={(event) => {event.stopPropagation(); openAudit(item.oid, item.status.key, item.failure_reason)}}>
                          <MyIcon name='shenhe' />
                        </div>
                      </Tooltip> */}
                      <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                        <div className='public-main-style2-operation' onClick={(event) => {event.stopPropagation(); deleteEvent(item.oid, item.name)}}>
                          <MyIcon name='huishouzhan' />
                        </div>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="6"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={eventData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isAddEventVisible && <AddAlumniEvent
          getEventData={getEventData} 
          isOpen={isAddEventVisible} 
          isCancel={() => { setIsAddEventVisible(false) }} 
        />}

        {isAlumniEventDetailVisible && <AlumniEventDetail
          data={propsData}
          getEventData={getEventData} 
          isOpen={isAlumniEventDetailVisible} 
          isCancel={() => { setIsAlumniEventDetailVisible(false) }} 
        />}

        {isDeleteEventVisible && <DeleteAlumniEvent
          data={propsData}
          getEventData={getEventData} 
          isOpen={isDeleteEventVisible} 
          isCancel={() => { setIsDeleteEventVisible(false) }} 
        />}

        {isAuditVisible && <AuditAlumniEvent
          data={propsData}
          getEventData={getEventData}
          isOpen={isAuditVisible}
          isCancel={() => { setIsAuditVisible(false) }}
        />}
      </div>
    </div>
  )
}
